import React from 'react';
import * as messages from '@radnuc/messages';

import { Map, Marker, TileLayer, GeoJSON, Popup, ImageOverlay, LatLngBounds } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import * as geojson from 'geojson';
import * as utm from 'utm'
import {BioInvestigation} from './BioInvestigationDisplay'

import { uuidToString } from '../utils/UUID';

import '@radnuc/react-ui-components/dist/MapDisplay.css'
import './IndoorMapDisplay.css'

import pin_industrial_logo from '@radnuc/react-ui-components/dist/img/pin-industrial.png'
import pin_medical_logo from '@radnuc/react-ui-components/dist/img/pin-medical.png'
import pin_norm_logo from '@radnuc/react-ui-components/dist/img/pin-norm.png'
import pin_biological_logo from './img/pin-biological.png'
import pin_biosigma_logo from './img/pin-biosigma.png'
import pin_generic_logo from '@radnuc/react-ui-components/dist/img/pin-generic-white-32.png'
import active_badge_logo from '@radnuc/react-ui-components/dist/img/active-investigation-badge.png'
import pin_shadown_logo from '@radnuc/react-ui-components/dist/img/marker-shadow.png'
import location_circle_logo from '@radnuc/react-ui-components/dist/img/ic_my_location_48px.png'
import location_circle_white_logo from './img/ic_my_location_48px_white.png'
import location_vector_logo from '@radnuc/react-ui-components/dist/img/ic_navigation_48px-32.png'
import location_vector_white_logo from '@radnuc/react-ui-components/dist/img/ic_navigation_48px-32_white.png'
import recenter_logo from '@radnuc/react-ui-components/dist/img/gps-navi-arrow-circle-32_white.png'
import recenter_on_alert_logo from '@radnuc/react-ui-components/dist/img/warning-lock-48_white.png'
import recenter_disabled_logo from '@radnuc/react-ui-components/dist/img/unlock-48_white.png'
import map_day_logo from '@radnuc/react-ui-components/dist/img/sun-day-bright-light-48_white.png'
import map_night_logo from '@radnuc/react-ui-components/dist/img/weather-night-48_white.png'

import gct_floorplan_pic from './img/GCT_main.png'
import gct_dining_floorplan_pic from './img/GCT_dining.png'
import { Core } from '@radnuc/messages';
import { BD21DataStream } from '../BD21DataStream';
import { CBSigmaContourDisplay, CBSigmaReleaseLocDisplay, CBSigmaContourKeyDisplay } from './MultiSensorMapDisplay';
import { CBSigmaOutput } from '../BD21Device';

type Investigation = messages.Encounter.Encounter | messages.Rad.Investigation;; //BioInvestigation;

export type SensorPosition = {
    device: string,
    timestamp: number,
    latitude: number | null,
    longitude: number | null,
    level: number | null,
}

interface InvestigationInterface {
    select: (key: Investigation) => void,
    unselect: () => void,
}

export interface IndoorMapDisplayProps {
    investigations: Investigation[],
    selectedInvestigation?: Investigation,
    investigationInterface: InvestigationInterface,
    liveStream: boolean,
    replayTime?: Date,
    sensorPositions: {[key: string]: SensorPosition},
    trackThisSensorLocation?: string | undefined,
    cbSigmaArray?: CBSigmaOutput[] | undefined,
}

export interface IndoorMapDisplayState {
    keep_vehicle_centered: boolean,
    recenter_on_alert: boolean,
    map_mode_day: boolean,
    map_mode_day_simple: boolean,
    plot_since: number,
    zoom_level: number,
    inv_selected: boolean,
    indoor_map_selected: string
}
type LatLonPoint = {
    lat: number,
    lon: number
}
type MapCorners={
    ul: LatLonPoint,
    ur: LatLonPoint,
    ll: LatLonPoint,
    lr: LatLonPoint
}
type IndoorMapReference = {
    mapUrl: string,
    mapCorners: MapCorners,
    mapSize:{height:number,width:number}
    mapLevel: number,
}

export class IndoorMapDisplay extends React.Component<IndoorMapDisplayProps, IndoorMapDisplayState> {
    //programmatic_map_control: boolean = false;
    map_element: React.RefObject<any>;
    //last_location_message: messages.Core.GPSReading | undefined;
    last_sensor_locations: {[key: string]: SensorPosition} | undefined;
    initialized: boolean = false;

    indoor_map_ref: IndoorMapReference | undefined;
    indoor_maps_available:{[key:string]: {title:string}};

    constructor(props: IndoorMapDisplayProps) {
        super(props)

        this.state = {
            keep_vehicle_centered: true,
            recenter_on_alert: true,
            map_mode_day: true,
            map_mode_day_simple: false,
            plot_since: 0,
            zoom_level: 0,
            inv_selected: false,
            indoor_map_selected: 'GCT_MAIN'
        }

        this.map_element = React.createRef<any>();

        this.handleUnselectButton = this.handleUnselectButton.bind(this);
        this.handleRecenterButtonClick = this.handleRecenterButtonClick.bind(this);
        this.handleRecenterOnAlertButtonClick = this.handleRecenterOnAlertButtonClick.bind(this);
        this.handleMapModeButtonClick = this.handleMapModeButtonClick.bind(this);
        this.handleDayMapTypeClick = this.handleDayMapTypeClick.bind(this);
        //this.rotateSourceImage = this.rotateSourceImage.bind(this);
        //this.handleClearTrailClick = this.handleClearTrailClick.bind(this);
        this.indoor_maps_available = {'GCT_MAIN':{title:'GCT Main Level'},'GCT_DINING':{title:'GCT Dining Level'}};
        this.setMapReference(this.state.indoor_map_selected);

    }

    componentDidMount() {
        this.patchMapTileGapBug();
        this.initialized = true;
    }

    componentDidUpdate(prevProps: IndoorMapDisplayProps, prevState: IndoorMapDisplayState) {
        //On New Investigation
        if (this.map_element.current !== null && this.props.investigations.length > prevProps.investigations.length) {
            if(this.state.recenter_on_alert){
                this.centerOnAlert();
            }
        }
        if(this.state.indoor_map_selected !== prevState.indoor_map_selected){
            this.setMapReference(this.state.indoor_map_selected);
        }
    }

    centerOnAlert(){
        this.setState(() => ({
            keep_vehicle_centered: true
        }));
        //this.props.investigationInterface.unselect();
    }

    enableRecenterButton() {
        if (this.last_sensor_locations !== undefined) {
            this.setState(() => ({
                keep_vehicle_centered: false
            }));
        }
    }

    getZoom(event: L.LayersControlEvent) {
        this.setState(() => ({
            zoom_level: event.target.getZoom(),
        }));
    }

    handleUnselectButton(event: React.MouseEvent<HTMLElement>) {
        this.props.investigationInterface.unselect();
        this.setState(() => ({
            keep_vehicle_centered: true
        }));
    }

    handleRecenterButtonClick(event: React.MouseEvent<HTMLElement>) {
        this.props.investigationInterface.unselect();
        this.setState(() => ({
            keep_vehicle_centered: true
        }));
    }

    handleRecenterOnAlertButtonClick(event: React.MouseEvent<HTMLElement>) {
        this.setState(() => ({
            recenter_on_alert: !this.state.recenter_on_alert
        }));
    }

    handleMapModeButtonClick(event: React.MouseEvent<HTMLElement>) {
        this.setState(() => ({
            map_mode_day: !this.state.map_mode_day
        }));
    }

    handleDayMapTypeClick(isSimple: boolean){
        this.setState(() => ({
            map_mode_day_simple: isSimple
        }));
    }

    /*
    handleClearTrailClick(){
        if(this.props.positions.length > 1){
            this.setState(() => ({
                plot_since: this.props.positions[this.props.positions.length-2].time
            }));
        } else if (this.props.positions.length === 1){
            this.setState(() => ({
                plot_since: this.props.positions[this.props.positions.length-1].time
            }));
        }
    }
    */
    patchMapTileGapBug() {
        // Workaround for 1px lines appearing in some browsers due to fractional transforms
        // and resulting anti-aliasing. adapted from @cmulders' solution:
        // https://github.com/Leaflet/Leaflet/issues/3575#issuecomment-150544739
        let originalInitTile = (L.GridLayer.prototype as any)._initTile;
        if (originalInitTile.isPatched) return;
        L.GridLayer.include({
            _initTile: function (tile: any) {
                originalInitTile.call(this, tile);

                var tileSize = this.getTileSize();

                tile.style.width = tileSize.x + 1 + 'px';
                tile.style.height = tileSize.y + 1 + 'px';
            }
        });
        (L.GridLayer.prototype as any)._initTile.isPatched = true;
    }


    setMapReference(mapname:string){
        const image_scale = 6;
        if(mapname === 'GCT_MAIN'){
            this.indoor_map_ref = {
                mapUrl:gct_floorplan_pic,
                //mapSize: {height:364, width:642},
                mapSize: {height:2641/image_scale, width:4661/image_scale},
                mapCorners: {
                    ll: {lat:40.752595, lon:-73.978787},
                    ur: {lat:40.752664, lon:-73.975070},
                    lr: {lat:40.751408, lon:-73.976000},
                    ul: {lat:40.753850, lon:-73.977858}
                },
                mapLevel: 1
            }
        }
        if(mapname === 'GCT_DINING'){
            this.indoor_map_ref = {
                mapUrl:gct_dining_floorplan_pic,
                mapSize: {height:1705/image_scale, width:4320/image_scale},
                mapCorners: {

                    ll: {lat:  40.752749, lon:-73.978365},
                    ur: {lat:  40.752603, lon: -73.975921},
                    lr: {lat:   40.751928, lon:-73.976425},
                    ul: {lat:  40.753433, lon:-73.977861}

                    /*
                    ll: {lat: 40.752733, lon:-73.978345},
                    ur: {lat: 40.752621, lon: -73.975921},
                    lr: {lat:  40.751938, lon:-73.976406},
                    ul: {lat: 40.753409, lon:-73.977865}
                    */
                },
                mapLevel: 0

            }
        }
    }

    convertLL2ImgCoord(lat:number,lon:number){
        const point = utm.fromLatLon(lat,lon)
        //console.log(lat,lon)
        if(this.indoor_map_ref ){
            const mapCornerLL_utm = utm.fromLatLon(this.indoor_map_ref.mapCorners.ll.lat,this.indoor_map_ref.mapCorners.ll.lon)
            const mapCornerUR_utm = utm.fromLatLon(this.indoor_map_ref.mapCorners.ur.lat,this.indoor_map_ref.mapCorners.ur.lon)
            const mapCornerLR_utm = utm.fromLatLon(this.indoor_map_ref.mapCorners.lr.lat,this.indoor_map_ref.mapCorners.lr.lon)
            const mapCornerUL_utm = utm.fromLatLon(this.indoor_map_ref.mapCorners.ul.lat,this.indoor_map_ref.mapCorners.ul.lon)

            const map_width_m = Math.sqrt((mapCornerLR_utm.easting - mapCornerLL_utm.easting)*(mapCornerLR_utm.easting - mapCornerLL_utm.easting) +
                                          (mapCornerLR_utm.northing - mapCornerLL_utm.northing)*(mapCornerLR_utm.northing - mapCornerLL_utm.northing))

            const map_height_m = Math.sqrt((mapCornerUL_utm.easting - mapCornerLL_utm.easting)*(mapCornerUL_utm.easting - mapCornerLL_utm.easting) +
                                           (mapCornerUL_utm.northing - mapCornerLL_utm.northing)*(mapCornerUL_utm.northing - mapCornerLL_utm.northing))

            //Calculate angle between left edge and y-axis for map rotation
            const a_dot_b = (mapCornerUL_utm.easting - mapCornerLL_utm.easting) * 0 + (mapCornerUL_utm.northing - mapCornerLL_utm.northing) * 1
            const mag_a = Math.sqrt(((mapCornerUL_utm.easting - mapCornerLL_utm.easting)*(mapCornerUL_utm.easting - mapCornerLL_utm.easting)) +
                                ((mapCornerUL_utm.northing - mapCornerLL_utm.northing)*(mapCornerUL_utm.northing - mapCornerLL_utm.northing)))

            const theta = Math.acos(a_dot_b / (mag_a));

            const yres = this.indoor_map_ref.mapSize.height/map_height_m; //pixels/m
            const xres = this.indoor_map_ref.mapSize.width/map_width_m; //pixels/m

            const x = xres*( (Math.cos(theta) * (point.easting-mapCornerLL_utm.easting)) - (Math.sin(theta) * (point.northing-mapCornerLL_utm.northing)))
            const y = yres*( (Math.sin(theta) * (point.easting-mapCornerLL_utm.easting)) + (Math.cos(theta) * (point.northing-mapCornerLL_utm.northing)))

            return {x:x,y:y}
        } else {
            return undefined
        }
    }

    convertInvestigationsToImgCoord(){
        let conv_investigations:Investigation[] = [];
        this.props.investigations.forEach(inv => {
            let inv_copy = JSON.parse(JSON.stringify(inv)) as messages.Encounter.Encounter
            inv_copy.id = inv.id as Core.UUID;
            if(this.indoor_map_ref){
                let node_name = inv_copy.node_name;
                node_name = BD21DataStream.remapDeviceName(node_name)
                node_name= node_name.replace(/_/g," ");
                if(this.props.sensorPositions[node_name]){
                    //Node Name exists in the sensor positions
                    const this_node_level = this.props.sensorPositions[node_name].level;
                    if(this_node_level === this.indoor_map_ref.mapLevel){
                        conv_investigations.push(inv_copy)
                    }
                } else if ('type' in inv && inv.type === messages.Encounter.EncounterType.BIOSIGMA && this.indoor_map_ref.mapLevel ===1){
                    //Display BioSIGMA result (This is a hack)
                    conv_investigations.push(inv_copy)
                }
            }
            //conv_investigations.push(inv_copy)
        });

        conv_investigations.forEach(inv => {
            if('type' in inv){
                if(inv.type === messages.Encounter.EncounterType.BIOSIGMA){
                    if(inv.source_location !== null){
                        if (inv.source_location.latitude !== null && inv.source_location.longitude !== null) {
                            const point = this.convertLL2ImgCoord(inv.source_location.latitude,inv.source_location.longitude);
                            if(point !== undefined){
                                inv.source_location.longitude = point.x;
                                inv.source_location.latitude = point.y;
                            }
                        }
                    }
                } else {
                    if(inv.vehicle_location.latitude !== null && inv.vehicle_location.longitude !== null){
                        const point = this.convertLL2ImgCoord(inv.vehicle_location.latitude,inv.vehicle_location.longitude);
                        if(point !== undefined){
                            inv.vehicle_location.longitude = point.x;
                            inv.vehicle_location.latitude = point.y;
                        }
                    }
                }
            }
        });

        return conv_investigations;
    }

    convertSensorPositionsToImgCoord(){
        let conv_sensorPositions: { [key: string]: SensorPosition } = {};
        Object.entries(this.props.sensorPositions).forEach(element => {
            let pos_copy = JSON.parse(JSON.stringify(element[1])) as SensorPosition
            if(this.indoor_map_ref){
                if(pos_copy.level === this.indoor_map_ref.mapLevel){
                    conv_sensorPositions[element[0]] = pos_copy;
                }
            }
        });

        Object.entries(conv_sensorPositions).forEach(element => {
            const this_device = element[0];
            let this_sensorPosition = element[1];
            if(this_sensorPosition.latitude !== null && this_sensorPosition.longitude !== null){
                const point = this.convertLL2ImgCoord(this_sensorPosition.latitude,this_sensorPosition.longitude)
                if(point !== undefined){
                    this_sensorPosition.longitude = point.x;
                    this_sensorPosition.latitude = point.y;
                }
                conv_sensorPositions[this_device] = this_sensorPosition
            }
        });
        return conv_sensorPositions;
    }

    convertCBSigmaOutputToImgCoord(cbSigmaOutput:CBSigmaOutput | undefined){

        let conv_cbSigmaOutput: CBSigmaOutput | undefined;
        if(cbSigmaOutput !== undefined){
            //this.props.cbSigmaArray.forEach(cbSigmaOutput => {
                let cbSigmaOutput_copy = JSON.parse(JSON.stringify(cbSigmaOutput)) as CBSigmaOutput;
                if(this.indoor_map_ref){
                    if(this.indoor_map_ref.mapLevel === 1){
                        conv_cbSigmaOutput = cbSigmaOutput_copy;
                    }
                }
            //});
            if(conv_cbSigmaOutput !== undefined){
                if(conv_cbSigmaOutput.contourLevels !== undefined && conv_cbSigmaOutput.contourLevels !== null && conv_cbSigmaOutput.contourLevels.length > 0){

                    conv_cbSigmaOutput.contourLevels.forEach((thisContourLevel:messages.CBSigmaReport.ContourLevel,idx) => {
                        if(thisContourLevel.contours !== undefined && thisContourLevel.contours !== null && thisContourLevel.contours.length > 0){
                            thisContourLevel.contours.forEach((thisContour:messages.CBSigmaReport.Contour) =>{
                                let outer_latlng: L.LatLngExpression[] = [];
                                if(thisContour.contour_outer){
                                    //console.log('Outer contour')
                                    thisContour.contour_outer.points.forEach((point:messages.Rad.Location) =>{
                                        const conv_point = this.convertLL2ImgCoord(point.latitude,point.longitude)
                                        if(conv_point !== undefined){
                                            point.longitude = conv_point.x;
                                            point.latitude = conv_point.y;
                                        }
                                    })
                                }
                                if(thisContour.contour_inner !== undefined && thisContour.contour_inner !== null && thisContour.contour_inner.length > 0){
                                    thisContour.contour_inner.forEach((thisHole:messages.CBSigmaReport.Polygon) =>{
                                        //console.log('Inner contour')
                                        let inner_latlng:L.LatLngExpression[] = [];
                                        thisHole.points.forEach((point:messages.Rad.Location) =>{
                                            const conv_point = this.convertLL2ImgCoord(point.latitude,point.longitude)
                                            if(conv_point !== undefined){
                                                point.longitude = conv_point.x;
                                                point.latitude = conv_point.y;
                                            }
                                        });
                                    });
                                }
                            });
                        }
                    });
                }
                if(conv_cbSigmaOutput.releaseLocation !== undefined && conv_cbSigmaOutput.releaseLocation !== null){
                    const conv_point = this.convertLL2ImgCoord(conv_cbSigmaOutput.releaseLocation.latitude,conv_cbSigmaOutput.releaseLocation.longitude)
                    if(conv_point !== undefined){
                        conv_cbSigmaOutput.releaseLocation.longitude = conv_point.x;
                        conv_cbSigmaOutput.releaseLocation.latitude = conv_point.y;
                    }
                    conv_cbSigmaOutput.estimatedReleaseTimestamp = cbSigmaOutput!.estimatedReleaseTimestamp;
                }
            }
            return conv_cbSigmaOutput;
        }
    }

    findCBSigmaAtTime(this_time:Date){
        let best_CBSigma;
        const this_timestamp = this_time.getTime();
        if(this.props.cbSigmaArray != undefined){
            if (this.props.cbSigmaArray.length > 0) {
                let min_time_diff = 100000;//new Date(this.props.positions[this.props.positions.length-1].time).getTime() - this_timestamp;
                this.props.cbSigmaArray.forEach(cbSigmaOutput => {
                    if((cbSigmaOutput.algorithmState !== messages.CBSigmaReport.AlgorithmState.DID_NOT_PROCESS &&
                        cbSigmaOutput.algorithmState !== messages.CBSigmaReport.AlgorithmState.DETECTING_NO_UPDATE) && cbSigmaOutput.isDetecting){
                        const cbSigmaOutputTimestamp_ms = cbSigmaOutput.timestamp; //*1000;
                        const this_time_diff = this_timestamp - cbSigmaOutputTimestamp_ms;
                        if(this_time_diff < min_time_diff && this_time_diff > 0){
                            best_CBSigma = cbSigmaOutput;
                            min_time_diff = this_time_diff
                        }
                    }
                });
            }
        }
        return best_CBSigma;
    }

    getInvOngoingBioSIGMA(investigations:Investigation[]){
        return investigations.filter((inv)=>{
                if('type' in inv){
                    if(inv.type === messages.Encounter.EncounterType.BIOSIGMA && !inv.finalized){
                        return true;
                    }
                }
                return false;
            });
    }

    render() {
        let keep_vehicle_centered = this.state.keep_vehicle_centered;
        let position: [number, number] | undefined;

        //var current_location_message;

        //TODO pick optimal position when nothing is selected
        if (this.props.sensorPositions !== undefined) {
            if(this.props.trackThisSensorLocation !== undefined){
                const this_sensor_loc = this.props.sensorPositions[this.props.trackThisSensorLocation];
                if(this_sensor_loc){
                    const this_lat = this_sensor_loc.latitude;
                    const this_lon = this_sensor_loc.longitude;
                    if(this_lat !== null && this_lon !== null){
                        position = [this_lat,this_lon];
                    }
                }
            } else {
                let avg_pos_lat = 0;
                let avg_pos_lon = 0;
                let num_pos = 0;
                Object.values(this.props.sensorPositions).forEach((loc) => {
                    if(loc.latitude !== null && loc.longitude !== null){
                        avg_pos_lat += loc.latitude;
                        avg_pos_lon += loc.longitude;
                        num_pos += 1;
                    }
                });
                if(num_pos >0){
                    avg_pos_lat = avg_pos_lat/num_pos;
                    avg_pos_lon = avg_pos_lon/num_pos;
                    position = [avg_pos_lat,avg_pos_lon];
                    this.last_sensor_locations = this.props.sensorPositions;
                }
            }
        }



        if (this.props.selectedInvestigation) {
            if(this.props.selectedInvestigation.vehicle_location === null){
                if('type' in this.props.selectedInvestigation && this.props.selectedInvestigation.source_location !== null){
                    if (this.props.selectedInvestigation.source_location.latitude !== null && this.props.selectedInvestigation.source_location.longitude !== null) {
                        position = [this.props.selectedInvestigation.source_location.latitude, this.props.selectedInvestigation.source_location.longitude];
                    }
                }
            } else {
                if (this.props.selectedInvestigation.vehicle_location.latitude !== null && this.props.selectedInvestigation.vehicle_location.longitude !== null) {
                    position = [this.props.selectedInvestigation.vehicle_location.latitude, this.props.selectedInvestigation.vehicle_location.longitude];
                }
            }
        }

        let map_center: [number, number] | undefined;
        if (this.state.keep_vehicle_centered || this.props.selectedInvestigation) {
            map_center = position;
        }
        //If map uninitialized, set mapt center to 0,0
        if (map_center === undefined && !this.initialized) {
            map_center = [0, 0];
        }

        let zoom_behavior: boolean | "center" = true;
        if (keep_vehicle_centered) {
            zoom_behavior = "center";
        }

        let unselectButton;
        if (this.props.selectedInvestigation) {
            unselectButton =
                <div className="round-button" style={{ position: 'absolute', right: '0px', top: '2px', padding: '5px' }} onClick={this.handleUnselectButton}>
                    <img src={pin_generic_logo} alt="Marker"/> <div style={{ width: '5px' }}> </div>UNSELECT
                </div>
        }

        let recenterButton;
        if ((!this.state.keep_vehicle_centered && this.last_sensor_locations !== undefined) || this.props.selectedInvestigation) {
            recenterButton =
                <div className="round-button" style={{ position: 'absolute', left: '0px', bottom: '2px', padding: '5px' }} onClick={this.handleRecenterButtonClick}>
                    <img src={location_circle_white_logo} alt="Recenter" /> <div style={{ width: '5px' }}> </div>RESUME TRACKING
                </div>
        }

        //Recenter on Alert button
        let recenter_status_img;
        if (this.state.recenter_on_alert) {
            recenter_status_img = recenter_on_alert_logo;
        } else {
            recenter_status_img = recenter_disabled_logo;
        }
        const recenterOnAlertButton =
            <div className="round-button" style={{ padding: '5px' }} onClick={this.handleRecenterOnAlertButtonClick}>
                <img src={recenter_status_img} alt="Recenter" />
            </div>


        //MapMode Button
        let map_mode_img;
        let map_url;
        let map_attribution;
        if (this.state.map_mode_day) {
            if(this.state.map_mode_day_simple){
                map_mode_img = map_day_logo;
                map_url = 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png';
                map_attribution = 'Map tiles by Carto, under CC BY 3.0. Data by OpenStreetMap, under ODbL';
            } else {
                map_mode_img = map_day_logo;
                map_url = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                map_attribution = "&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
            }
        } else {
            map_mode_img = map_night_logo;
            map_url = "https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png";
            map_attribution = "Map tiles by Carto, under CC BY 3.0. Data by OpenStreetMap, under ODbL";
        }

        const mapModeButton =
            <div className="round-button" style={{ padding: '5px' }} onClick={this.handleMapModeButtonClick}>
                <img src={map_mode_img} alt="Day/Night Toggle" />
            </div>
        let background_color;
        if (this.state.map_mode_day) {
            background_color = 'white';
        } else {
            background_color = 'black';
        }

        const indoorMapsAvailable = Object.keys(this.indoor_maps_available).map((mode) =>
            <option value={mode} key={mode}>{this.indoor_maps_available[mode].title}</option>)

        const indoorMapSelectDisplay =
            <div style={{ display: 'flex', position: 'absolute', left: '44px', bottom: '-42px', padding: '5px' }}>
                <div style={{display:'flex',flexDirection:'row', background:'#eeeeee',  borderRadius:'5px', padding:'1px' }}>
                <div style={{display:'flex',flexDirection:'row'}}>
                    <label className="dropdown-title-light">{'Level:'}</label>
                    <select className="modern-skinny-light" value={this.state.indoor_map_selected}
                        onChange={(e) => {
                            console.log(e)
                            const this_indoor_map_selected = e.target.value;
                            this.setState(() => ({
                                indoor_map_selected: this_indoor_map_selected
                            }));
                            this.setMapReference(e.target.value);
                        }}>
                        {indoorMapsAvailable}
                    </select>
                </div>
                </div>
            </div>

            let cbsigma_contours;
            let cbsigma_release_loc;
            let cbsigma_contour_key;
            let cbsigma_release_time;
            if(this.props.cbSigmaArray !== undefined){
                let thisCBSigmaOutput;
                if(this.props.replayTime){
                    thisCBSigmaOutput = this.findCBSigmaAtTime(this.props.replayTime);
                } else {
                    if(this.getInvOngoingBioSIGMA(this.props.investigations).length > 0){
                        thisCBSigmaOutput = this.props.cbSigmaArray[0];
                    }
                }
                if(thisCBSigmaOutput){
                    const conv_cbSigmaOutput = this.convertCBSigmaOutputToImgCoord(thisCBSigmaOutput);
                    cbsigma_contours = <CBSigmaContourDisplay cbSigmaOutput={conv_cbSigmaOutput}/>
                    cbsigma_release_loc = <CBSigmaReleaseLocDisplay cbSigmaOutput={conv_cbSigmaOutput} darkmap={!this.state.map_mode_day}/>

                    cbsigma_contour_key = <CBSigmaContourKeyDisplay cbSigmaOutput={conv_cbSigmaOutput} darkmap={!this.state.map_mode_day}/>
                }
            }


        const conv_sensorPositions = this.convertSensorPositionsToImgCoord();
        const current_locations = <MultiPositionMarkerDisplay locations={conv_sensorPositions} mapModeDay={this.state.map_mode_day} />


        //Image Layer
        let floorplanLayer;
        if (this.indoor_map_ref){
            map_center = [this.indoor_map_ref.mapSize.height/2,this.indoor_map_ref.mapSize.width/2]
            floorplanLayer = <ImageOverlay url={this.indoor_map_ref.mapUrl} bounds={[[0, 0], [this.indoor_map_ref.mapSize.height, this.indoor_map_ref.mapSize.width]]}/>
        }

        const conv_investigations = this.convertInvestigationsToImgCoord();

        return (
            <>
                <div style={{ display: 'flex', position: 'relative', justifyContent: 'flexStart', zIndex:9998 }}>
                    {indoorMapSelectDisplay}
                </div>
                <div style={{ display: 'flex', position: 'relative', justifyContent: 'flexEnd' }}>
                    {unselectButton}
                </div>
                <Map center={map_center} zoom={this.state.zoom_level} animate={false} onDragStart={this.enableRecenterButton.bind(this)} tap={true} drag={true} crs={L.CRS.Simple}
                    onZoomEnd={this.getZoom.bind(this)} maxZoom={3} zoomSnap={0.1} touchZoom={zoom_behavior} scrollWheelZoom={zoom_behavior} ref={this.map_element} style={{ backgroundColor: background_color }}>
                    {floorplanLayer}
                    {cbsigma_contours}
                    {cbsigma_release_loc}
                    <BioInvestigationMarkerDisplay
                        investigations={conv_investigations}
                        selectedInvestigation={this.props.selectedInvestigation}
                        investigationInterface={this.props.investigationInterface}
                    />
                    {current_locations}
                </Map>
                <div style={{ display: 'flex', position: 'relative', justifyContent: 'spaceBetween', bottom: '15px' }}>
                    {recenterButton}
                </div>
                <div style={{ display: 'flex', position: 'relative', justifyContent: 'flexEnd', bottom: '15px', minWidth:'300px'}}>
                    {cbsigma_contour_key}
                    <div style={{ display: 'flex', position: 'absolute', right: '0px', bottom: '2px', padding: '5px' }}>
                        {mapModeButton}
                        {recenterOnAlertButton}
                    </div>
                </div>

                {/*HIDDEN DIVS FOR EXPERT SETTINGS*/}
                <div className={"map-select-day-map-simple-hidden"} style={{display:'none'}} onClick={()=>{this.handleDayMapTypeClick(true)}}/>
                <div className={"map-select-day-map-detailed-hidden"} style={{display:'none'}} onClick={()=>{this.handleDayMapTypeClick(false)}}/>
            </>
        )
    }
}
export default IndoorMapDisplay

/******************************************************************************/

export interface MultiPositionMarkerDisplayProps {
    locations: {[key:string]:SensorPosition} | undefined,
    mapModeDay: boolean
}

export class MultiPositionMarkerDisplay extends React.Component<MultiPositionMarkerDisplayProps> {
    render() {
        let position_markers: JSX.Element[] = [];

        if (this.props.locations !== undefined) {
            Object.values(this.props.locations).forEach((loc) => {
                if(loc.latitude !== null && loc.longitude !== null){
                    var position_icon;
                    var logo;
                    if (this.props.mapModeDay) {
                        logo = location_circle_logo;
                    } else {
                        logo = location_circle_white_logo;
                    }
                    position_icon = L.divIcon({
                        className: 'leaflet-div-icon-clear',
                        html:
                            '<div id="map_vehicle_icon" style="opacity:0.6;"><img src="' + logo + '"></div>',
                        iconSize: [32, 32],
                        iconAnchor: [17, 17],
                    });

                    const key = loc.device; //+'_'+loc.timestamp.toFixed();
                    const position_marker =
                        <Marker position={[loc.latitude, loc.longitude]}
                            icon={position_icon}
                            data={key}
                            key={key}>
                            <Popup>
                                {loc.device}
                            </Popup>
                        </Marker>
                    position_markers.push(position_marker);
                }
            });
        }
        return (
            position_markers
        )
    }
}

/******************************************************************************/

export interface BioInvestigationMarkerDisplayProps {
    investigations: Investigation[],
    selectedInvestigation?: Investigation,
    investigationInterface: InvestigationInterface,
}

export class BioInvestigationMarkerDisplay extends React.Component<BioInvestigationMarkerDisplayProps> {
    constructor(props: BioInvestigationMarkerDisplayProps) {
        super(props)

        this.handleSelectClick = this.handleSelectClick.bind(this);
        this.getPinImg = this.getPinImg.bind(this);
    }

    handleSelectClick(event: React.MouseEvent<HTMLElement>) {
        let marker = event.target as any;
        this.props.investigationInterface.select(marker.options.data);
    }

    getPinImg(inv: Investigation) {
        var img = null
        img = pin_biological_logo;
        if('type' in inv){
            if(inv.type === messages.Encounter.EncounterType.BIOSIGMA){
                img = pin_biosigma_logo;
            }
        }

        /*
        if (inv.isotopes.length > 0) {
            if (inv.isotopes[0].category.toUpperCase() === 'MEDICAL') {
                img = pin_medical_logo;
            }
            if (inv.isotopes[0].category.toUpperCase() === 'INDUSTRIAL') {
                img = pin_industrial_logo;
            }
            if (inv.isotopes[0].category.toUpperCase() === 'RDD') {
                img = pin_industrial_logo;
            }
            if (inv.isotopes[0].category.toUpperCase() === 'SNM') {
                img = pin_nuclear_logo;
            }
            if (inv.isotopes[0].category.toUpperCase() === 'NUCLEAR') {
                img = pin_nuclear_logo;
            }
            if (inv.isotopes[0].category.toUpperCase() === 'NORM') {
                img = pin_norm_logo;
            }
        } else {
            img = pin_generic_logo;
        }
        */
        return (img);
    }

    render() {
        //Investigation Markers
        let markers: JSX.Element[] = [];
        this.props.investigations.forEach((inv) => {
            const key = uuidToString(inv.id);

            let opacity = '0.8';
            if (this.props.selectedInvestigation && inv.id !== this.props.selectedInvestigation.id) {
                opacity = '0.0';
            }

            let visibility_active_badge = 'visible';
            if (inv.finalized) {
                visibility_active_badge = 'hidden';
            }

            const markerIcon = L.divIcon({
                className: 'leaflet-div-pin-icon-clear',
                html:
                    '<div id="inv_' + key + '">' +
                    '<img src="' + this.getPinImg(inv) +
                    '" style="position:relative; opacity:' + opacity + '; transition: all 0.5s" width="32" height="48">' +
                    '<img src="' + pin_shadown_logo + '" style="position:absolute; opacity:' + opacity + '; transition: all 0.5s; left:3px; bottom:-1px"></div>' +
                    '<img class="map-pin-active-badge" src="' + active_badge_logo +
                    '" style="visibility:' + visibility_active_badge +
                    ';position:absolute; opacity:' + opacity + '; transition: all 0.5s; left: 6px; bottom:48px" width="20" height="20">' +
                    '</div>',
                iconSize: [32, 48],
                iconAnchor: [15, 47],
            });
            if ('type' in inv){
                if(inv.type === messages.Encounter.EncounterType.BIOSIGMA){
                    if(inv.source_location !== null){
                        if (inv.source_location.latitude !== null && inv.source_location.longitude !== null) {
                            var marker =
                                <Marker position={[inv.source_location.latitude, inv.source_location.longitude]}
                                    icon={markerIcon}
                                    data={inv}
                                    selected={this.props.selectedInvestigation && inv.id === this.props.selectedInvestigation.id}
                                    onClick={(event: React.MouseEvent<HTMLElement, MouseEvent>) => this.handleSelectClick(event)}
                                    key={key}>
                                </Marker>
                            markers.push(marker);
                        }
                    }
                } else {
                    if (inv.vehicle_location.latitude !== null && inv.vehicle_location.longitude !== null) {
                        const marker =
                            <Marker position={[inv.vehicle_location.latitude, inv.vehicle_location.longitude]}
                                icon={markerIcon}
                                data={inv}
                                selected={this.props.selectedInvestigation && inv.id === this.props.selectedInvestigation.id}
                                onClick={(event: React.MouseEvent<HTMLElement, MouseEvent>) => this.handleSelectClick(event)}
                                key={key}>
                            </Marker>
                        markers.push(marker);
                    }
                }
            }
        });

        return (
            markers
        )
    }
}

/******************************************************************************/
/*
export interface DoseTrailDisplayProps {
    positions: messages.Core.GPSReading[],
    radiationData: messages.Rad.RadiationReading[],
    plotSince: number
}

export class DoseTrailDisplay extends React.Component<DoseTrailDisplayProps> {
    dose_min: number = 1.e8;
    dose_max: number = 0.0;
    dose_ave: number = 0;
    dose_range: number = 0;
    dose = 0.0;
    constructor(props: DoseTrailDisplayProps) {
        super(props)

        this.doseColorMap = this.doseColorMap.bind(this);
        this.doseRateFeatureStyle = this.doseRateFeatureStyle.bind(this);
    }
    //GEOJSON STYLE
    doseColorMap(counts: number, ave_counts: number, min_counts: number, count_range: number) {
        if (counts === 0) {
            return 'rgb(0,0,0)';
        } else if (counts < ave_counts) {
            return 'rgb(0,0,' +
                Math.floor((counts - min_counts) / count_range * 255) + ')';
        } else {
            return 'rgb(0,' +
                Math.floor((counts - ave_counts) / count_range * 255) +
                ',255)';
        }
    }

    doseRateFeatureStyle = (feature: any) => {
        return {
            color:
                this.doseColorMap(feature.properties.counts, this.dose_ave, this.dose_min, this.dose_range),
            opacity: 1,
            weight: 5
        };
    };

    render() {
        //Dose Lines
        var ndoses = 0, dose_sum = 0.0;
        this.dose_min = 1.e8;
        this.dose_max = 0.0;
        this.dose_ave = 0;
        this.dose_range = 0;
        this.dose = 0.0;
        var dose_lines: geojson.Feature[] = [];
        //var poly_lines: L.LatLngExpression[] = [];
        var prev_position: number[] | null = null;
        this.props.positions.forEach((gps_reading) => {
            var time = gps_reading.time;
            var position = [gps_reading.lon, gps_reading.lat];
            var dose = 0.0;
            if( time > this.props.plotSince){
                if (this.props.radiationData !== null) {
                    if (this.props.radiationData.length > 0) {
                        var match_idx: number | null = null;
                        var prev_diff: number | null = null;
                        this.props.radiationData.forEach((rad_reading, idx) => {
                            var this_diff = rad_reading.time - gps_reading.time;
                            if (prev_diff != null) {
                                if (this_diff <= 0) {
                                    //Difference Negative=>GPS time is newer
                                    if (this_diff > prev_diff) {
                                        //current is newer than prev without being newer than GPS
                                        if (Math.abs(this_diff) < 10000) {
                                            match_idx = idx;
                                        }
                                    }
                                }
                            } else {
                                prev_diff = this_diff;
                            }
                        });

                        if (match_idx != null) {
                            var sum_count = 0;
                            var sum_dose = 0;
                            this.props.radiationData[match_idx].detectors.forEach((det) => {
                                det.spectrum.forEach((count) => {
                                    sum_count += count;
                                });
                                sum_dose += det.dose_rate;
                            })

                            dose = sum_count;
                            dose_sum += dose;
                            this.dose_min = Math.min(this.dose_min, dose);
                            this.dose_max = Math.max(this.dose_max, dose);
                            ndoses += 1;
                        } else {
                            dose = 0;
                        }
                    }
                }

                if (prev_position !== null) {
                    var new_feature: geojson.Feature = {
                        "type": "Feature",
                        "properties": { "time": time, "counts": dose },
                        "geometry": {
                            "type": "LineString",
                            "coordinates": [prev_position, position]
                        }
                    };
                    dose_lines.push(new_feature);
                }
                prev_position = position;
            }

        });
        if (ndoses > 0) {
            this.dose_ave = dose_sum / ndoses;
            this.dose_range = Math.max(this.dose_max - this.dose_ave, this.dose_ave - this.dose_min);
        } else {
            this.dose_ave = 0;
            this.dose_range = 0;
        }
        var key = new Date().getTime(); //Change in key triggers the GeoJSON redraw

        return (
            <GeoJSON key={key} data={dose_lines} style={this.doseRateFeatureStyle} />
        )

    }

}
*/
